import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from '@material-ui/core';
import ExpandMore from '@material-ui/icons/ExpandMore';

const PhotoErrorBoxList = ({ data }) => (
  <Accordion
    style={{
      fontSize: '0.85rem',
      fontFamily: 'Montserrat, Helvetica, Arial, sans-serif',
      fontWeight: '400',
      lineHeight: '1.6',
      color: '#951d32',
      backgroundColor: '#fed6dd',
      marginBottom: '1rem',
      borderRadius: '0.25rem',
      boxShadow: 'none',
      position: 'static',
    }}
  >
    <AccordionSummary expandIcon={<ExpandMore />}>
      При загрузке изображений произошло ошибок: {data.length} шт.
    </AccordionSummary>
    <AccordionDetails style={{ display: 'block' }}>
      {data.map((item) => (
        <div key={item.photoNumber}>
          <ul style={{ listStyle: 'none', padding: '0' }}>
            <li>Фото {item.photoNumber} не загружено по причине:</li>
            <li>-{item.message}</li>
          </ul>
        </div>
      ))}
    </AccordionDetails>
  </Accordion>
);

export default PhotoErrorBoxList;
